import { Component, ChangeDetectorRef, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { JourneyProvider, InstanceProvider, Company, ContentProvider, ExternalContentProvider, ManageLearnerProvider } from '@lighty';
import { HttpHelper, DataHelper, UrlHelper } from '@helpers';
import { EmitterService, ScriptInjectorService, StorageService, TranslateService } from '@services';
import { TutorContextStateService } from '../../../services/tutor-context-state.service';
import { CookieService } from 'ngx-cookie-service';
import { SubscriptionCollection } from '@classes';
import { CommonToastService } from '@common2/services/toast.service';
import * as _ from 'lodash';
import { environment } from '@env/environment';
import { CarouselComponent, OwlOptions } from 'ngx-owl-carousel-o';
import { take } from 'rxjs';
import { switchMap, filter } from 'rxjs/operators';


const CONTENT_NAVIGATION = (that: LearnDetailComponent, translateService: TranslateService) => {
    return [
        {
            label: translateService.instant('words.presentation'),
            isHidden: false,
            routerLink: that.context !== 'external-content' ? [that.context, that.contextId, 'presentation'] : [that.context, that.type, that.contextId, 'presentation']
        },
        {
            label: translateService.instant('words.table-contents'),
            isHidden: !(that.context !== 'journey' && that.context !== 'external-content' || (that.context === 'journey' && that.subscribed)),
            routerLink: [that.context, that.contextId, 'presentation']
        },
        {
            label: translateService.instant('words.corrections'),
            isHidden: !(that.context === 'instance' || (that.context === 'journey' && that.subscribed) && that.hasCorrections),
            routerLink: [that.context, that.contextId, 'corrections']
        },
        {
            label: translateService.instant('words.conversation'),
            isHidden: !(that.enableDiscussion && ((that.context === 'journey' && that.subscribed) || that.context === 'instance')),
            routerLink: [that.context, that.contextId, 'discussion']
        },
        {
            label: translateService.instant('words.activities-log'),
            isHidden: !(that.context === 'external-content' && that.subscribed),
            routerLink: [that.context, that.type, that.contextId, 'result']
        },
    ]
}

@Component({
    selector: 'msc-learn-detail',
    templateUrl: './detail.component.html',
    styleUrls: ['./detail.component.scss']
})

  
export class LearnDetailComponent {
    @ViewChild('carousel', { static: false }) carousel!: CarouselComponent;
    private subscriptionCollection: SubscriptionCollection = new SubscriptionCollection();
    public company: Company;
    public background: string = 'https://static.myskillcamp.com/lxp/images/hero-catalog.png';
    public context: string;
    public contextId: number;
    public type: string;
    public message: string;
    public subscribed: boolean = false;
    public saved: boolean = false;
    public onDemand: boolean = false;
    public translation: string;
    public isVisibleSubscriptionMenu: boolean = false;
    public hasCorrections: boolean = false;
    public canUnsubscribe: boolean = true;
    public navigation;
    public account;
    public title: string;
    public isFromSubscriptions: boolean;
    public buttons: any;
    public contents: any;
    public contentDetails: any;
    public isLoading: boolean = false;
    public carouselItems: any[] = [];
    public summary: any;
    public ratingInfo: any;
    public ratingComments: any[] = [];
    
    public carouselOptions: OwlOptions = {
        loop: true,
        margin: 14, // Espacio entre los elementos
        stagePadding: 14, // Espacio en los lados del carrusel
        mouseDrag: true,
        touchDrag: true,
        pullDrag: true,
        dots: false,
        navSpeed: 400,
        nav: false,
        navText: ['', ''],
        center: false,
        startPosition: 0,
        items: 4,
        responsive: {
            0: {
                items: 1 // Muestra 1 elemento en pantallas pequeñas
            },
            425: {
                items: 1
            },
            540: {
                items: 1
            },
            600: {
                items: 2 // Muestra 2 elementos en pantallas medianas
            },
            768: {
                items: 3 // Muestra 3 elementos en pantallas medianas
            },
            1360: {
                items: 4 // Muestra 4 elementos en pantallas grandes
            },
            1536: {
                items: 4 // Muestra 4 elementos en pantallas grandes
            },
            1600: {
                items: 5 // Muestra 5 elementos en pantallas grandes
            }
        }
    };

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private check: ChangeDetectorRef,
        private instanceProvider: InstanceProvider,
        private journeyProvider: JourneyProvider,
        private storageService: StorageService,
        private contentProvider: ContentProvider,
        private externalContentProvider: ExternalContentProvider,
        private emitterService: EmitterService,
        private toastService: CommonToastService,
        private cookieService: CookieService,
        private scriptInjectorService: ScriptInjectorService,
        private translateService: TranslateService,
        private tutorContextStateService: TutorContextStateService,
    ) {
        this.scriptInjectorService.platformEmbedly();
    }

    get enableDiscussion(): boolean { return this.getEnableDiscussion(); }

    //* SLIDER COMENTARIOS
   // SLIDER COMENTARIOS
@ViewChild('sliderComments') slider!: ElementRef<HTMLElement>;
private resizeObserver: ResizeObserver;

private setupResizeObserver() {
  this.resizeObserver = new ResizeObserver(entries => {
    const containerWidth = entries[0].contentRect.width;
    this.updateScrollBehavior(containerWidth);
  });
  this.resizeObserver.observe(this.slider.nativeElement);
}

private updateScrollBehavior(containerWidth: number) {
  const CARD_MARGIN = 16; // mx-2 (8px * 2)
  let cardsPerView: number;
  
  if (containerWidth >= 1800) {
    cardsPerView = 5;
  } else if (containerWidth >= 1500) {
    cardsPerView = 4;
  } else if (containerWidth >= 1200) {
    cardsPerView = 3;
  } else if (containerWidth >= 768) {
    cardsPerView = 2;
  } else {
    cardsPerView = 1;
  }

  // Ajustar padding para centrado
  const cardWidth = (containerWidth / cardsPerView) - CARD_MARGIN;
  this.slider.nativeElement.style.scrollSnapType = `x mandatory`;
}

scrollAmount(): number {
  const container = this.slider.nativeElement;
  const firstCard = container.querySelector('.flex-shrink-0') as HTMLElement;
  return firstCard ? firstCard.offsetWidth + 16 : 0; // 16px = space-x-4
}

scrollLeft(): void {
  this.slider.nativeElement.scrollBy({
    left: -this.scrollAmount() * 3, // Mueve 3 cards
    behavior: 'smooth'
  });
}

scrollRight(): void {
  this.slider.nativeElement.scrollBy({
    left: this.scrollAmount() * 3, // Mueve 3 cards
    behavior: 'smooth'
  });
}
    

    ngOnInit(): void {
        this.company = this.storageService.get('company');
        this.background = this.company.experience && this.company.experience.cataloguePicture ? this.company.experience.cataloguePicture + '?size=raw' : this.background;
        this.context = this.router.url.split('/')[4];
        this.isFromSubscriptions = (this.context === 'instance' || this.context === 'journey' || this.context === 'external-content') && this.subscribed;
        this.emitterService.get('has-corrections').subscribe((hasCorrections: boolean) => {
            this.hasCorrections = hasCorrections ? hasCorrections : false;
        });

        if (this.context === 'external-content') {
            this.contextId = parseInt(this.router.url.split('/')[6], 10);
            this.type = this.router.url.split('/')[5];
        } else {
            this.contextId = parseInt(this.router.url.split('/')[5], 10);
        }

        this.route.firstChild.params.subscribe(() => {
            if (this.context === 'external-content') {
                this.saved = this.route.firstChild.snapshot.data.externalContent.saved
                this.subscribed = this.route.firstChild.snapshot.data.externalContent.subscribed;
                this.applyDetailPostAssignments(this.route.firstChild.snapshot.data[_.camelCase(this.context)]);
            } else if (this.context === 'journey') {
                // JourneyResolver ya no resuelve el objeto Journey directo -- ver { journey$ }
                // (no bloquea la navegación, JourneyProvider.getDetail() emite progresivamente).
                // Nos suscribimos acá y aplicamos los mismos campos que antes se leían síncronos
                // del snapshot, en cuanto llega la primera respuesta real (no el esqueleto) --
                // leer route.firstChild.snapshot.data.journey.id directo (como antes) daría
                // undefined, porque ahora esa clave es { journey$ }, no el Journey en sí.
                this.route.firstChild.data.pipe(
                    switchMap((data: any) => data.journey.journey$),
                    filter((journey: any) => !journey.isSkeleton),
                    take(1)
                ).subscribe((journey: any) => {
                    this.saved = this.storageService.get('journey') ? this.storageService.get('journey').saved : journey.saved;
                    this.subscribed = this.storageService.get('journey') ? this.storageService.get('journey').subscribed : journey.subscribed;
                    this.account = this.storageService.get('journey') ? this.storageService.get('journey').account : journey.account;
                    this.applyDetailPostAssignments(journey);
                });
                return;
            } else {
                this.saved = this.route.firstChild.snapshot.data[this.context].saved;
                this.onDemand = this.route.firstChild.snapshot.data[this.context].onDemand;
                this.subscribed = this.route.firstChild.snapshot.data[this.context].subscribed;
                this.account = this.route.firstChild.snapshot.data[this.context].account;
                this.applyDetailPostAssignments(this.route.firstChild.snapshot.data[_.camelCase(this.context)]);
            }
        });

        this.subscriptionCollection.subscribe = this.emitterService.get('refreshSubscription').subscribe((data) => {
            if (data && data.subscribed) {
                this.subscribed = data.subscribed;
            }
            this.setSubscriptionMenuVisibility(this.context, this.subscribed);
        });

        this.subscriptionCollection.subscribe = this.emitterService.get('clipboardWhiteURL').subscribe(data => {
            if (typeof data === 'boolean') {
                this.clipboard();
            }
        });

        this.translation = this.getTranslation();
        this.navigation = CONTENT_NAVIGATION(this, this.translateService);

        this.setReferrer();
        // Desactivado (no borrado): llamar esto acá, síncrono, asumía que this.contentDetails ya
        // estaba seteado -- cierto mientras todos los resolvers eran bloqueantes. Con
        // JourneyResolver ya no bloqueante (ver más arriba), para context='journey' esto
        // corre ANTES de que llegue la primera respuesta real y this.contentDetails sigue
        // undefined -- movido a applyDetailPostAssignments(), que se llama para los 3 contextos
        // (journey/instance/external-content) justo cuando su contentDetails real ya está listo.
        // this.getRatingComments();
        //this.detectContentType();
    }

    /**
     * Común a los 3 contextos (journey/instance/external-content): antes vivía inline dentro de
     * route.firstChild.params.subscribe(), asumiendo que route.firstChild.snapshot.data ya tenía
     * el objeto real -- ya no es así para 'journey' (ver JourneyResolver, ahora resuelve
     * { journey$ } sin bloquear la navegación). Se llama síncrono para instance/external-content
     * (sin cambios de comportamiento ahí) y async, cuando llega la primera respuesta real, para
     * journey.
     */
    private applyDetailPostAssignments(contentDetails: any): void {
        this.title = contentDetails?.title || 'Untitled';
        this.contentDetails = contentDetails;
        this.tutorContextStateService.setContext({
            source: 'detail-view',
            contentType: this.context,
            contentId: this.contextId,
            contentTitle: this.title,
            contentDescription: this.contentDetails?.description || this.contentDetails?.longDescription || '',
        });
        if (this.route.firstChild.snapshot.data.summary) {
            this.summary = this.route.firstChild.snapshot.data.summary;
        }
        if (this.route.firstChild.snapshot.data.summary?.subscription?.isFromGroup) {
            this.canUnsubscribe = false;
        }
        this.setSubscriptionMenuVisibility(this.context, this.subscribed);
        this.getRatingComments();
    }

    ngAfterViewInit(): void {
      

        this.buttons = document.querySelectorAll('.tab-button');
        this.contents = document.querySelectorAll('.tab-content');
        console.log(this.contents);
        this.buttons.forEach(button => {
            button.addEventListener('click', () => {
              // Quitar clases de activo a todos los botones
              this.buttons.forEach(btn => {
                btn.classList.remove('bg-gray-100', 'text-gray-700');
                btn.classList.add('bg-transparent', 'text-gray-700');
              });
              // Ocultar todos los contenidos
              this.contents.forEach(content => {
                content.classList.add('hidden');
              });
         
              // Activar el botón clickeado
              button.classList.remove('bg-transparent', 'text-gray-700');
              button.classList.add('bg-gray-100', 'text-gray-700');
         
              // Mostrar el contenido correspondiente (asumiendo que el id del contenido es "info" + el número del botón)
              const infoId = button.id.replace('btn', 'info');
              document.getElementById(infoId).classList.remove('hidden');
            });
          });
         
         
          // ACORDEON
          document.querySelectorAll('.toggle-btn').forEach(button => {
             button.addEventListener('click', () => {
               const content = button.nextElementSibling;
               content.classList.toggle('hidden');
         
               // Alternar el color del texto al hacer clic
               button.classList.toggle('text-primary');
             });
           });
        this.getContent();
    }

    getEnableDiscussion() {
        switch (true) {
            case this.route.firstChild.snapshot?.data.hasOwnProperty('instance'): return this.route.firstChild?.snapshot?.data?.instance?.discussionEnabled;
            case this.route.firstChild.snapshot?.data.hasOwnProperty('journey'): return this.route.firstChild?.snapshot?.data?.journey?.discussionEnabled;
            default: return false;
        }
    }

    ngAfterViewChecked(): void {
        this.check.detectChanges();
    }

    ngOnDestroy(): void {
        this.storageService.delete('journey');
        this.subscriptionCollection.unsubscribe();
        this.tutorContextStateService.clearContext();
    }

    deleteContent(data): void {
        if (this.context === 'journey') {
            this.journeyProvider.unsubscribe(this.contextId).subscribe(() => {
                this.router.navigate(['/learn', this.company.slug, 'contents']);
            });
        } else if (this.context === 'instance') {
            const params = HttpHelper.cleanParams({
                message: this.message
            });

            this.instanceProvider.unsubscribe(this.contextId, params).subscribe(() => {
                this.toastService.onSuccess(this.translateService.instant('toast.unregister'));
                this.router.navigate(['/learn', this.company.slug, 'contents']);
            });
        } else {
            if (this.type === 'external_video') {
                const params = {
                    provider: 'external_video'
                };

                this.externalContentProvider.unsubscribeVideo(this.contextId, params).subscribe(() => {
                    this.router.navigate(['/learn', this.company.slug, 'contents']);
                    this.toastService.onSuccess(this.translateService.instant('toast.unregister'));
                });
            } else {
                this.externalContentProvider.unsubscribe(this.contextId).subscribe(() => {
                    this.router.navigate(['/learn', this.company.slug, 'contents']);
                    this.toastService.onSuccess(this.translateService.instant('toast.unregister'));
                });
            }
        }
    }

    navigate(): void {
        if (this.cookieService.get('referrer_content')) {
            this.router.navigateByUrl(this.cookieService.get('referrer_content'));
        } else {
            if (this.isFromSubscriptions) {
                this.router.navigate(['/learn', this.company.slug, 'contents']);
            } else {
                this.router.navigate(['/learn', this.company.slug, 'catalogue']);
            }
        }
    }

    private getTranslation(): string {
        if (this.context === 'instance' || ((this.context === 'journey' || this.context === 'external-content') && this.subscribed)) {
            return 'words.my-courses';
        } else {
            return 'words.catalogue';
        }
    }

    private setSubscriptionMenuVisibility(context: string, subscribed: boolean): void {
        this.isVisibleSubscriptionMenu = (context === 'instance' || ((context === 'journey' || context === 'external-content') && subscribed)) && this.canUnsubscribe;
    }

    clipboard(): void {
        if (this.company.customUrl) {
            if (this.company.customUrl.slice(-1) === '/') {
                DataHelper.clipboard(`${this.company.customUrl}${location.pathname.substring(1)}`);
            } else {
                DataHelper.clipboard(`${this.company.customUrl}${location.pathname}`);
            }
        } else {
            DataHelper.clipboard(location.href);
        }
        this.toastService.onSuccess(this.translateService.instant('toast.link-clipboard'));
    }

    private setReferrer(): void {
        if (this.storageService.get('referrer')) {
            this.cookieService.set('referrer_content', this.storageService.get('referrer'), 10, '/', UrlHelper.getDomain(), false, 'Lax');
        }
    }


    changeLearnLaterContent(): void {
        this.saved = !this.saved;
        let context = '';
        let context_id = 0;

        if(this.route.firstChild.snapshot.data.hasOwnProperty('instance')) {
            context = 'course_template';
            context_id = this.route.firstChild.snapshot.data.instance.id;
        } else if (this.route.firstChild.snapshot.data.hasOwnProperty('journey')) {
            context = 'traject';
            // route.firstChild.snapshot.data.journey ya no es el objeto Journey directo -- es
            // { journey$ } (JourneyResolver no bloquea la navegación, ver más arriba). El id real
            // ya está en this.contentDetails, poblado por applyDetailPostAssignments() en cuanto
            // llega la primera respuesta real.
            context_id = this.contentDetails?.id;
        } else if(this.route.firstChild.snapshot.data.hasOwnProperty('external_content')) {
            context = 'external_content';
            context_id = this.route.firstChild.snapshot.data.externalContent.id;
        } else {
            this.emitterService.set('changeLearnLaterContent', this.saved);
        }

        let params = {
            context: context,
            context_id: context_id
        }

        if(this.saved){
            this.contentProvider.addSavedContent(params).subscribe(() => {
                console.log('saving')
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.saved'));
            });
        } else {
            this.contentProvider.deleteSavedContent(params).subscribe(() => {
                console.log('deleting')
                this.toastService.onSuccess(this.translateService.instant('toast.learn-later.deleted'));
            });
        }
    }

    openConversation(): void {
        this.storageService.set('conversationUsers', [this.account]);
        this.router.navigate(['conversation', 'create']);
    }

    public prev(): void {
        this.carousel.prev();
    }

    public next(): void {
        this.carousel.next();
    }

    public getContent(): void {
        this.carouselItems = [];
        const params = {
            company_id: this.company.id,
            per_page: 10
        };
        this.contentProvider.getContents(params).subscribe((data) => {
            this.carouselItems = data.contents;
            this.isLoading = false;
        });
    }

    public convertSecondsToHoursMinutes(seconds: number): string {
        if (seconds < 0 || isNaN(seconds)) {
          return '0h0m';
        }
      
        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
      
        return `${hours}h${minutes}m`;
      }

    public getRatingComments(): void {
        if (!this.contentDetails?.id) {
            return;
        }

        this.ratingComments = [];
        const params = {
            contentId: this.contentDetails.id,
            contentType : this.detectContentType()
        }
        this.contentProvider.getRatingsComments(this.company.id, params).pipe(take(1)).subscribe((data) => {
            this.ratingComments = data.comments;
            console.log('rating comments', this.ratingComments)
        });
    }

    public getStars(rating: number): number[] {
        return Array(rating).fill(0);
      }

    public detectContentType(): string {
        const url = this.router.url;
        let contentType = '';

        const keywords = ['external-content', 'journey', 'instance'];

        const match = keywords.find(keyword => url.includes(keyword));

        if (match) {
            contentType = match;
            console.log('Keyword encontrada:', contentType);
        }

        if( contentType === 'journey') {
            contentType = 'traject';
        } else if (contentType === 'instance') {
            contentType = 'course';
        } else {
            contentType = 'external_content';
        }

        return contentType;
    }

}
